module.exports = __webpack_public_path__ + "static/moonamar-kaltgepresstes-bio-schwarzkummelol-100-ml-c82be7f3889fddcb4175a2c1525b1ff7.png";